export function formatLicensePlate(licensePlate: string, sideCode: number) {
  const cleaned = licensePlate.replace(/-/g, '').toUpperCase();

  const formats: Record<number, number[]> = {
    1: [2, 2, 2],
    2: [2, 2, 2],
    3: [2, 2, 2],
    4: [2, 2, 2],
    5: [2, 2, 2],
    6: [2, 2, 2],
    7: [2, 3, 1],
    9: [2, 3, 1],
    8: [1, 3, 2],
    10: [1, 3, 2],
    11: [3, 2, 1],
    14: [3, 2, 1],
    12: [1, 2, 3],
    13: [1, 2, 3],
  };

  const pattern = formats[sideCode];
  if (!pattern) return cleaned;

  let formatted = '';
  let index = 0;
  pattern.forEach((length, i) => {
    if (i > 0) formatted += '-';
    formatted += cleaned.substr(index, length);
    index += length;
  });

  return formatted;
}
